module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-3-2-b35fcd801ba1013b0159dbcb0dc1b390.jpg";